import { CloseIcon, Flex, InfoIcon, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

export default function AlertN2F400({ hideShowAlert, minAmount }) {
    return (
        <AlertContainer vAlign="center" fill gap="gap.smaller">
            <InfoIcon outline />
            <Text
                content={`Pour toute dépense > ${minAmount} CHF (TTC), une facture complète est obligatoire (nom fournisseur, date, montant, TVA).Les tickets ne sont pas suffisants`}
            />
            <CloseIcon onClick={hideShowAlert} />
        </AlertContainer>
    );
}

const AlertContainer = styled(Flex)`
    border-radius: 4px;
    border: 1px solid #d1d1d1;
    background: #e0e0e0;
    padding: 6px 6px 6px 16px;
`;
